import React from 'react';
import * as _ from 'lodash';
import InfinityScrollLoad from './InfinityScrollLoad';
import { DragAndDropSpace } from './DnDWrapper';
import { messageUtility } from '../utilities/messageUtility';

/**
 * @description リスト一覧共通コンポーネント
 *
 * @param {Function} onLoad リストデータ取得処理。(必須)
 * @param {Function} header ヘッダーのComponentを返す関数。(必須)
 * @param {Function} body   リストの要素Componentを返す関数。(必須)
 * @param {String} parentId スクロールイベントを張るDOMのID。(必須)
 * @param {Object} params   通信する時の params。(必須)
 * @param {Boolean} isNewSearch   検索ボタン押下時、InfinityScroll無効するためのフラグ。(必須)
 */
export class Table extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      list_data: [],
    };

    this.reset_flag = false; // resetフラグ
    this.id = new Date().getTime().toString(16) + Math.random().toString(16);
  }

  async componentDidMount() {
    await this.onLoad(() => {});
  }

  async componentWillReceiveProps(nextProps) {
    if (nextProps.isLoading) {
      this.setState({ list_data: [] });
    }

    if (nextProps.isFetch) {
      this.reset_flag = true;
      let data = await this.props.onLoad([]);

      if (_.isArray(data)) {
        this.setState({ list_data: data });
      } else {
        this.setState({ list_data: [] });
      }
    }
  }

  /**
   * @description 追加ロード
   */
  async onLoad(notify) {
    let data = await this.props.onLoad(this.state.list_data);

    if (_.isArray(data)) {
      this.setState({ list_data: this.state.list_data.concat(data) });

      if (data.length) {
        notify();
      } else {
        notify('end');
      }
    }
  }

  /**
   * @description 並び順を変更する
   * @param {Object} dragIndex
   * @param {Number} to_index
   */
  sortList(dragIndex, to_index) {
    const lists = _.cloneDeep(this.state.list_data);
    const { index } = dragIndex;
    // eslint-disable-next-line no-unused-vars
    const toItem = lists[to_index];
    const formItem = lists[index];
    if (to_index < index) {
      lists.splice(to_index, 0, formItem);
      lists.splice(index + 1, 1);
    } else {
      lists.splice(to_index + 1, 0, formItem);
      lists.splice(index, 1);
    }
    this.setState({ list_data: lists });
  }

  /**
   * @description headerを返す。
   */
  setHeader() {
    if (this.props.header) {
      return this.props.header(this.state);
    } else {
      return null;
    }
  }

  /**
   * @description ボディーを返す。
   */
  setBody() {
    if (this.props.body) {
      return _.map(this.state.list_data, (data, i) => {
        const key = `${this.id}-${i}`;

        return this.props.body({
          data,
          key,
          index: i,
          id: this.id,
          canDrag: this.props.canSort,
          onBeginDrag: () => ({ index: i }),
          onDropped: result => this.sortList(result, i),
        });
      });
    }

    return null;
  }

  /**
   * @description リストが空の時、表示する
   */
  setDefaultBody() {
    if (this.props.isLoading) {
      return <div className='indicator' />;
    }

    if (this.state.list_data.length === 0) {
      return (
        <div className='table__message'>
          {messageUtility.getMessage('I-000-005')}
        </div>
      );
    }

    return null;
  }

  render() {
    const reset = this.reset_flag;
    if (reset) {
      this.reset_flag = false;
    }

    return (
      <DragAndDropSpace>
        <table className='table'>
          {this.setHeader()}
          <tbody>{this.setBody()}</tbody>
        </table>

        {this.setDefaultBody()}

        {!this.props.isNewSearch && (
          <InfinityScrollLoad
            reset={reset}
            targetId={this.props.parentId}
            callback={this.onLoad.bind(this)}
          />
        )}
      </DragAndDropSpace>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CommonTable.jsx